import React from 'react'

const Fleet = () => {
  return (
    <div>Fleet</div>
  )
}

export default Fleet